import React, {FC} from 'react';
import cn from 'classnames';

import {useFhs, useFhsActor} from '../../store/FhsContext/hooks';
import type {FhsField, IconOption} from '../../types';
import {buildIconClassName} from '../../utils';

import styles from './styles.module.scss';

interface QuestionCardCheckboxProps {
  field: FhsField;
  options: IconOption[];
}

const QuestionCardCheckbox: FC<QuestionCardCheckboxProps> = ({
  field,
  options,
}) => {
  const actor = useFhsActor();
  const {formData, errors, touched} = useFhs();

  const raw = formData[field];
  const current = Array.isArray(raw) ? raw : [];
  // Built once rather than rescanned twice per option rendered below.
  const selected = new Set(current);
  const error = touched[field] ? errors[field] : undefined;

  return (
    <div className={styles.questionCardCheckbox}>
      <div className={styles.questionCardCheckbox__grid}>
        {options.map((opt) => {
          const isSelected = selected.has(opt.value);

          return (
            <label
              key={opt.value}
              className={styles.questionCardCheckbox__card}>
              <input
                type="checkbox"
                name={String(field)}
                value={opt.value}
                checked={isSelected}
                aria-label={opt.label}
                className={styles.questionCardCheckbox__input}
                onChange={() =>
                  actor.send({
                    type: 'TOGGLE_MULTI_CHOICE',
                    field,
                    value: opt.value,
                  })
                }
              />
              <i
                className={cn(
                  styles.questionCardCheckbox__icon,
                  buildIconClassName(opt, isSelected),
                )}
                aria-hidden
              />
              <span className={styles.questionCardCheckbox__label}>
                {opt.label}
              </span>
            </label>
          );
        })}
      </div>
      <div className={styles.questionCardCheckbox__errorSlot}>
        {error && <p className={styles.questionCardCheckbox__error}>{error}</p>}
      </div>
    </div>
  );
};

export default QuestionCardCheckbox;
